import { PersonalCodeResult } from '@app/lib/personal-code/model/PersonalCodeResult';

export function parseLithuanianPersonalCode(personalCode: string): PersonalCodeResult {
    if (!/^\d{11}$/.test(personalCode)) {
        return { isValid: false };
    }

    const firstDigit = parseInt(personalCode[0]);

    if (![3, 4, 5, 6].includes(firstDigit)) {
        return { isValid: false };
    }

    const year = parseInt(personalCode.substring(1, 3));
    const month = personalCode.substring(3, 5);
    const day = personalCode.substring(5, 7);
    let century: number;
    const gender: 'male' | 'female' = firstDigit % 2 === 1 ? 'male' : 'female';

    switch (firstDigit) {
        case 3:
        case 4:
            century = 1900;
            break;
        case 5:
        case 6:
            century = 2000;
            break;
        default:
            return { isValid: false };
    }

    const fullYear = century + year;
    const birthDate = `${fullYear}-${month}-${day}`;
    const today = new Date();
    const birthDateObj = new Date(fullYear, parseInt(month) - 1, parseInt(day));
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
        age--;
    }

    return {
        isValid: true,
        year: fullYear,
        age,
        gender,
        birthDate,
    };
}
